import { PlusIcon, TrashIcon } from "@heroicons/react/24/outline"

import improvement from "assets/svg/improvement.svg"
import { Button, Input, ModalWrapper } from "components"
import React, { useState, useEffect } from "react"
import { useMutation } from "@tanstack/react-query"
import {
  ReviewEntityFeedbackBody,
  performanceService,
} from "services/performanceService"
import { onQueryError } from "utils/utils"
import { useAppNotificationStore } from "stores"
import { IReviewEntityFeedbacks } from "../interface/listings"
import { mixPanelEvent } from "components/new-stuff/mix-panel/MixPanel"
export const AreaOfImprovement: React.FC<{
  employeeReviewId: string | number
  invalidateQueries: Function
  feedback: IReviewEntityFeedbacks[] | any[]
}> = ({ employeeReviewId, invalidateQueries, feedback }) => {
  const { toast } = useAppNotificationStore()
  const [updatedGoal, setUpdatedGoal] = useState(feedback)
  const [activeGoal, setActiveGoal] = useState("")
  const [showAddNew, setShowAddNew] = useState(false)
  const [activeDeleteFeedback, setActiveDeleteFeedback] = useState("")
  const [deleteModal, setDeleteModal] = useState(false)

  const { isLoading, mutate: saveResponse } = useMutation({
    mutationFn: (body: ReviewEntityFeedbackBody) =>
      performanceService.saveReviewFeedback(body),
    onSuccess: (data) => {
      invalidateQueries()
      data.message && toast.success(data.message)
      mixPanelEvent("pf-review-improvement-add-success")
      setUpdatedGoal([
        {
          description: activeGoal,
        },
        ...feedback,
      ])
      setShowAddNew(false)
      setActiveGoal("")
    },
    onError: onQueryError,
  })
  const { isLoading: isLoadingDelete, mutate: deleteFeedback } = useMutation({
    mutationFn: () =>
      performanceService.deleteReviewFeedback(activeDeleteFeedback),
    onSuccess: (data) => {
      data.message && toast.success(data.message)
      mixPanelEvent("pf-review-improvement-delete-success")
      invalidateQueries()
      setDeleteModal(false)
      setActiveDeleteFeedback("")
    },
    onError: (error) => {
      setDeleteModal(false)
      setActiveDeleteFeedback("")
      onQueryError(error)
    },
  })

  const handleAddFeedback = () => {
    const body = {
      review_entity_id: String(employeeReviewId),
      review_entity_feedback_type_id: "3",
      description: activeGoal,
    }
    saveResponse(body)
  }
  const handleDelete = () => {
    deleteFeedback()
  }
  useEffect(() => {
    setUpdatedGoal(feedback)
  }, [feedback])
  return (
    <div className=" mt-8 font-avenir flex flex-col gap-4  relative">
      <div className="bg-white   rounded-5px    shadow-card">
        <div className=" ">
          <h4 className="text-sm sm:text-base font-extrabold text-neutral700 my-4 px-4 sm:px-[22px]">
            Areas of improvement
          </h4>
          <div className="border border-neutral50 w-full mb-[14px]" />
          <div className=" flex flex-col gap-4 px-4 sm:px-5">
            {" "}
            {updatedGoal.length ? (
              updatedGoal.map((dev, index) => (
                <div
                  key={index}
                  className="min-h-[52px] max-h-[120px] overflow-y-scroll rounded-5px border border-cardgrey justify-between items-center px-4 sm:px-5 flex"
                >
                  <div className="flex items-center gap-2">
                    <img
                      src={improvement}
                      alt="improvement"
                      className=" w-5 h-5"
                    />

                    <h6 className="text-neutral700  text-sm sm:text-base font-medium">
                      {dev.description}
                    </h6>
                  </div>
                  <p
                    className=" text-danger400 text-sm font-medium cursor-pointer"
                    onClick={() => {
                      setDeleteModal(true)
                      setActiveDeleteFeedback(dev.review_entity_feedback_id)
                    }}
                  >
                    <TrashIcon className="w-4 h-4" />
                  </p>
                </div>
              ))
            ) : (
              <div className="text-neutral500 font-medium flex justify-center items-center w-full pt-10 ">
                No available areas of improvement
              </div>
            )}
            {showAddNew && (
              <div className=" border border-neutral30 sm:py-6 sm:px-3 rounded-5px">
                <div className=" bg-[#f3f5fbcf] sm:p-2 rounded-5px h-auto border border-neutral30 flex flex-col justify-between gap-2 ">
                  <Input
                    type={"text"}
                    name={""}
                    // id="mobile-number"
                    required={true}
                    placeholder="Improvement title"
                    value={activeGoal}
                    onChange={(e) => {
                      setActiveGoal(e.target.value)
                    }}
                    className="px-2 sm:px-3  text-sm border-none focus:border border-[#C2C7D0] !bg-transparent"
                  />

                  <div className="flex items-center justify-end gap-2 mt-3">
                    <Button
                      color="secondary"
                      onClick={() => {
                        setActiveGoal("")
                        setShowAddNew(false)
                      }}
                    >
                      Cancel
                    </Button>

                    <Button
                      color="primary"
                      submitting={isLoading}
                      disabled={activeGoal == "" ? true : false}
                      // onClick={handleAddGoals}
                      onClick={() => {
                        handleAddFeedback()
                        mixPanelEvent("pf-review-improvement-add-init")
                      }}
                    >
                      Add improvement
                    </Button>
                  </div>
                </div>
              </div>
            )}
            {deleteModal && (
              <ModalWrapper
                title="Delete area of improvement"
                onClose={() => {
                  setDeleteModal(false)
                  setActiveDeleteFeedback("")
                }}
              >
                <div className="px-5 py-3 flex flex-col items-center">
                  <p className="text-[#15294B] text-sm mb-6">
                    If you delete this improvement, it would be removed from
                    your list. Are you sure you want to continue?
                  </p>
                </div>
                <div className="border py-5 px-6 flex gap-4  justify-end">
                  <Button
                    title="cancel"
                    color="secondary"
                    onClick={() => {
                      setDeleteModal(false)
                      setActiveDeleteFeedback("")
                    }}
                  >
                    Cancel
                  </Button>

                  <Button
                    title="remove"
                    color="primary"
                    submitting={isLoadingDelete}
                    onClick={() => {
                      handleDelete()
                      mixPanelEvent("pf-review-improvement-delete-init")
                    }}
                  >
                    Confirm
                  </Button>
                </div>
              </ModalWrapper>
            )}
            <button
              className="mt-6  text-xs sm:text-sm  text-primary500 flex items-center gap-2 mb-3 font-extrabold"
              onClick={() => setShowAddNew(!showAddNew)}
            >
              <PlusIcon className="w-5 stroke-2" />
              <p>Add areas of improvement</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
